import { FleekError } from './FleekError';

type ObjectId = {
  id?: string;
};

type UnstoppableDeploymentErrorOptions = {
  deployment: ObjectId;
};

export class UnstoppableDeploymentError extends FleekError<UnstoppableDeploymentErrorOptions> {
  public name = 'UnstoppableDeploymentError';

  toString = () => `Deployment cannot be stopped.`;
}
